function ProfilePending() {
    console.log("Page loaded, profile pending");

    return (
        <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-green-50 to-blue-50">
            <div className="bg-white p-8 rounded-2xl shadow-lg w-full max-w-md text-center">
                <h1 className="text-2xl font-bold text-gray-800 mb-4">
                    We’re reviewing your profile
                </h1>
                <p className="text-gray-500 mb-6">
                    Our team is verifying your details. We’ll notify you once your
                    account is activated.
                </p>
            </div>
        </div>
    );
}

export default ProfilePending;  